import { render, staticRenderFns } from "./MapListSwitch.vue?vue&type=template&id=223991b4&scoped=true"
import script from "./MapListSwitch.vue?vue&type=script&lang=js"
export * from "./MapListSwitch.vue?vue&type=script&lang=js"
import style0 from "./MapListSwitch.vue?vue&type=style&index=0&id=223991b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223991b4",
  null
  
)

export default component.exports